import { render, staticRenderFns } from "./CardInformation.vue?vue&type=template&id=513e98e3&"
import script from "./CardInformation.vue?vue&type=script&lang=js&"
export * from "./CardInformation.vue?vue&type=script&lang=js&"
import style0 from "./CardInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports